/*=========================================================================================
  File Name: module-usertax-mutations.js
  Description: UserTax Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */
import { MSEnum } from '@/common/enumeration';
import msDateUtil from '@/components/msdatepicker/msDateUtil';

export default {};
